import { RouteRecordRaw } from 'vue-router';
import { route } from '@/router/utils'
// import { allPermissions } from '@access/index'
// import { accessPermission } from '@/permissions/permissions'

// const {
//   STAFF: {
//     USER: {
//       VIEW
//     },
//   },
// } = allPermissions

const view = () => import('./views/View.vue')

export const PROFILE_PAGE_NAME = 'cabinet:profile'

// URLs
export const PROFILE_PAGE_URL = ''

export function createRoutes(options): RouteRecordRaw[] {
  return [
    route(PROFILE_PAGE_URL, view, PROFILE_PAGE_NAME, {
      meta: {
        breadcrumb: 'profile',
        // ...accessPermission([VIEW], options),
        isMain: true, withoutBreadcrumbs: true,
      }
    }),
  ]
}
